'use client';

type FormSeparatorProps = {
  text: string;
};

export const FormSeparator = ({ text }: FormSeparatorProps) => {
  return (
    <div className='mt-8 mb-4 flex w-full max-w-96 items-center gap-4'>
      <div className='h-px flex-1 bg-gray-300' />
      <span className='text-sm'>{text}</span>
      <div className='h-px flex-1 bg-gray-300' />
    </div>
  );
};
